module.exports = __webpack_public_path__ + "static/media/ML.593dcabf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ML.svg
// module id = 2209
// module chunks = 7